$(function () {

    $('.AvailableUnits__toggle').on('click', function () {
        $('.AvailableUnits__content').slideToggle();
    });

    $('.AvailableUnits__unit').on('click', function () {
        var floor = $(this).data('floor');
        var phase = $(this).data('phase');
        displayFloor(floor, phase);

        var unit = $(this).data('unit');
        displayUnit(unit);

        $('html, body').animate({
            scrollTop: $('.Plan').offset().top
        });
    });

    $('.plan-availability').on('click', function () {
        $('html, body').animate({
            scrollTop: $('.Plan').offset().top
        });
    });

    $('.Plan__overview select')
        .on('create', function () {
            $('.selectboxit-arrow').text('keyboard_arrow_down');
        })
        .on('change', function (event) {
            var bedrooms = $('.Plan__overview__options [name=bedrooms]').val();
            var surface_area = $('.Plan__overview__options [name=surface-area]').val();

            var conditions = {};
            if (bedrooms != 'all') {
                conditions.bedrooms = bedrooms;
            }

            if (surface_area != 'all') {
                conditions.surface_area = surface_area;
            }

            $('.Plan__overview__floor.active').removeClass('active');

            if (false == (conditions.hasOwnProperty('bedrooms') || conditions.hasOwnProperty('surface_area'))) {
                return;
            }

            conditions.status = "available";

            $.ajax({
                url: '/api/plans',
                type: 'get',
                data: conditions
            }).done(function (data) {
                var floors = {};

                $.each(data, function (index, unit) {
                    floors[unit.phase + '-' + unit.floor] = true;
                });

                for (key in floors) {
                    key = key.split('-');
                    phase = key[0];
                    floor = key[1];

                    $('.Plan__overview__floor[data-floor=' + floor + '][data-phase=' + phase + ']').addClass('active');
                }
            });
        })
        .selectBoxIt({
            hideCurrent: true,
            autoWidth: false,
            downArrowIcon: 'material-icons',
            dynamicPositioning: false
        });

    $('.Plan__overview__floor').on('click', function () {
        var floor = $(this).data('floor');
        var phase = $(this).data('phase');
        displayFloor(floor,phase);
    });

    $('.Plan__details .back-to-the-future').on('click', function (event) {
        event.preventDefault();

        $('.Plan > .container').fadeToggle(function () {
            $('.Plan__overview').fadeToggle();
        });
    });

    if ($('#hbs-unit').size()) {
        var hbs_details = Handlebars.compile($('#hbs-unit').html());
    }

    $('.Plan').on('click', '.Plan__details__floor__unit', function () {
        var unit = $(this).data('unit');
        displayUnit(unit);
    });


    function displayFloor(floor,phase) {

        var conditions = {
            floor: floor,
            phase: phase
        };

        $.ajax({
            url: '/api/plans',
            type: 'get',
            data: conditions
        }).done(function (data) {
            var svg = $('.Plan__details #floor-p' + phase + '-' + floor);

            $('.Plan__details svg').hide();
            $('.Plan__details__floor__filters li').remove();
            $('.Plan .Plan__details__unit').remove();
            $('.Plan__details__floor__unit').removeClass('Plan__details__floor__unit--available');
            $('.Plan__details__floor__unit').removeClass('Plan__details__floor__unit--booked');
            $('.Plan__details__floor__unit').removeClass('Plan__details__floor__unit--sold');
            $('.Plan__details__floor__unit').removeClass('active');

            if ($('.Plan__overview select[name=bedrooms]').val() != 'all') {
                var text = $('.Plan__overview select[name=bedrooms] option[value="' + $('.Plan__overview select[name=bedrooms]').val() + '"]').text();
                $('.Plan__details__floor__filters').append($('<li/>').text(text));
            }

            if ($('.Plan__overview select[name=surface-area]').val() != 'all') {
                var text = $('.Plan__overview select[name=surface-area] option[value="' + $('.Plan__overview select[name=surface-area]').val() + '"]').text();
                $('.Plan__details__floor__filters').append($('<li/>').text(text));
            }

            $.each(data, function (index, unit) {
                var element = svg.find('[data-unit="' + unit.suite + '"]');

                element.addClass('Plan__details__floor__unit--' + unit.status)

                var bedrooms = $('.Plan__overview select[name=bedrooms]').val();

                var surface_area = $('.Plan__overview select[name=surface-area]').val();

                if (bedrooms != 'all' && surface_area != 'all') {
                    if (bedrooms == unit.bedrooms && surface_area == unit['surface-area']) {
                        element.addClass('active');
                    }
                } else if (bedrooms != 'all' && surface_area == 'all') {
                    if (bedrooms == unit.bedrooms) {
                        element.addClass('active');
                    }
                } else if (bedrooms == 'all' && surface_area != 'all') {
                    if (surface_area == unit['surface-area']) {
                        element.addClass('active');
                    }
                }
            });

            $('.Plan__details__floor__title span').text(floor);

            $('.Plan__details__floor__caption .panorama a.hidden').remove();

            if (phase == 1) {
                var panorama_file = '/images/frontend/panoramas/p1/';

                if (floor >= 1 && floor <= 3) {
                    panorama_file += '1-3.jpg';
                } else if (floor >= 4 && floor <= 7) {
                    panorama_file += '4-7.jpg';
                } else if (floor >= 8 && floor <= 11) {
                    panorama_file += '8-11.jpg';
                } else if (floor >= 12 && floor <= 16) {
                    panorama_file += '12-16.jpg';
                } else if (floor >= 17 && floor <= 20) {
                    panorama_file += '17-20.jpg';
                }

                $('.Plan__details__floor__caption .panorama a:first').attr('href', panorama_file);

            } else if (phase == 2) {
                var panorama_file = '/images/frontend/panoramas/p2/';
                var images = [];

                if (floor >= 1 && floor <= 4) {
                    images = ['2-6-o.jpg', '2-6-s.jpg', '2-6-e.jpg'];
                } else if (floor >= 5 && floor <= 6) {
                    images = ['2-6-o.jpg', '2-6-s.jpg', '2-6-e.jpg', '2-6-n.jpg'];
                } else if (floor >= 7 && floor <= 9) {
                    images = ['7-9-o.jpg', '7-9-s.jpg', '7-9-e.jpg', '7-9-n.jpg'];
                } else if (floor >= 10 && floor <= 14) {
                    images = ['10-14-o.jpg', '10-14-s.jpg', '10-14-e.jpg', '10-14-n.jpg'];
                } else if (floor >= 15 && floor <= 18) {
                    images = ['15-18-o.jpg', '15-18-s.jpg', '15-18-e.jpg', '15-18-n.jpg'];
                } else if (floor >= 19 && floor <= 22) {
                    images = ['19-22-o.jpg', '19-22-s.jpg', '19-22-e.jpg', '19-22-n.jpg'];
                } else if (floor >= 23 && floor <= 24) {
                    images = ['23-24-o.jpg', '23-24-s.jpg', '23-24-e.jpg', '23-24-n.jpg'];
                } else if (floor == 25) {
                    images = ['25-s.jpg', '25-e.jpg', '25-n.jpg'];
                }

                for (index in images) {
                    var image = images[index];

                    if (index == 0) {
                        $('.Plan__details__floor__caption .panorama a:first').attr('href', panorama_file + image);
                    } else {
                        $('<a/>')
                            .attr('href', panorama_file + image)
                            .attr('data-lightbox', 'panorama')
                            .addClass('hidden')
                            .appendTo('.Plan__details__floor__caption .panorama');
                    }
                }
            }

            svg.show();

            if( $('.Plan__overview').is(':visible') ) {
                $('.Plan__overview').fadeToggle(function () {
                    $('.Plan > .container').fadeToggle();
                });
            }
        });
    }

    function displayUnit(unit) {
        var conditions = {
            suite: unit
        };

        $.ajax({
            url: '/api/plans',
            type: 'get',
            data: conditions
        }).done(function (data) {
            var unit = data[0];
            $('.Plan .Plan__details__unit').remove();
            unit.surface_area_translated = $('.Plan__overview select[name=surface-area] option[value="' + unit['surface-area'] + '"]').text();
            unit.bedrooms_translated = $('.Plan__overview select[name=bedrooms] option[value="' + unit.bedrooms + '"]').text();
            $('.Plan__details').append(hbs_details(unit));
        });
    }
});


// WEBPACK FOOTER //
// ./public/js/plans.js